import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="border-b border-border bg-accent/10 text-center text-foreground" aria-label="Limited time offer" data-id="element-203" data-mp="2sk46nkhn1yb1">
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-204" data-mp="36c23owy2s3qu">
        <p className="inline-flex items-center gap-2 text-sm font-semibold text-accent" data-id="element-205" data-mp="31i6b6a0kz932">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-206" data-mp="3g7c8fsfuyp8b" /> Launch pricing ends in:
        </p>
        <Countdown className="mt-5" data-id="element-207" data-mp="3b7zbufz6q3sj" />
        <p className="mt-6 font-medium text-muted" data-id="element-208" data-mp="3bb51bwbq77os">After that the price increases and never drops again.</p>
      </div>
    </section>;
}